export default __webpack_public_path__ + "static/media/body-average.b7c907c4.png";